var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-map-stations-content"},_vm._l((_vm.stations),function(station,stationIdx){return _c('map-tooltip',{key:stationIdx,attrs:{"is-current-station":_vm.isCurrentStation(stationIdx),"label":station.label,"position":{ x: station.x, y: station.y },"station-idx":stationIdx},on:{"tooltip-hovered":_vm.onTooltipHovered}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }